module.exports = __webpack_public_path__ + "static/img/NOAH-CHAMBERLAIN.0cf2f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NOAH-CHAMBERLAIN.jpg
// module id = IRuw
// module chunks = 0